export default __webpack_public_path__ + "static/media/Mark-3-HUD-11.2c24160c.jpg";